import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class ToastService {
	isActive = false;
	constructor(private toastr: ToastrService) { }

	public error<T>(error: T, title: string = '', properties?: any): void {
		const message: any = error;
		const header = title ? title : 'An Error Occurred';
		if (typeof message === 'object') {
			if(typeof message.error === 'object') {
				if (message.error && message.error.Detail) {
					this._error(message.error.Detail, header, properties);
				} else if (message.error && message.error.Message) {
					this._error(message.error.Message, header, properties);
				} else if (message.message) {
					this._error(message.message, header, properties);
				} else {
					this._error(error ? error.toString() : 'Error', header, properties);
				}
			} else if (typeof message.error === 'string') {
				const errorMessage = JSON.parse(message.error);
				this._error(errorMessage.Detail, header, properties);
			}
		} else if (typeof message === 'string') {
			this._error(message, header, properties);
		} else {
			this._error(error ? error.toString() : 'Error', header, properties);
		}
	}

	private _error(message = '', title = '', properties?: any) {
		properties = properties ? properties : {};
		properties.disableTimeOut = true;
		properties.closeButton = true;
		properties.tapToDismiss = false;
		this.isActive = true;
		this.toastr.error(message, title, properties)
		.onHidden
		.pipe(take(1))
		.subscribe(() => this.toasterClickedHandler());
	}
	success(message = '', title = '', properties?: any) {
		properties = properties ? properties : {};
		this.toastr.success(message, title, properties);
	}
	info(message = '', title = '', properties?: any) {
		properties = properties ? properties : {};
		this.toastr.info(message, title, properties);
	}
	warning(message = '', title = '', properties?: any) {
		properties = properties ? properties : {};
		this.toastr.warning(message, title, properties);
	}
	private toasterClickedHandler() {
		this.isActive = false;
	}
}
